import { render, staticRenderFns } from "./OkModal.vue?vue&type=template&id=282f9d84&lang=pug"
import script from "./OkModal.vue?vue&type=script&lang=ts"
export * from "./OkModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports